var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float_btn_dialog_title"},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('i',{staticClass:"jeicon jeicon-error close",on:{"click":_vm.handleClose}})])}
var staticRenderFns = []

export { render, staticRenderFns }